


<app-website-header></app-website-header>

<div class="container-fluid">

    <section class="about">
        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>


        <div class="row" >
            <div class="col-sm-1"></div>

            <div class="about-image">
                <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 45px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: 0.32px;
                text-align: left;
                color: #ff6d11;">Services</p>
                <p style="margin-top:-33px;"><img src="assets/section-images/Path 336.png"> </p>
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 24px"></div>
        </div>
        <div class="row" >
            <div class="col-sm-1"></div>

            <div class="col-sm-2" style="margin-left: -14px;">
               <a href="federal" class="services"><p> <span style="font-weight: bolder;" > ></span> Federal & State Filing  </p></a>
               <a href="itIn"class="services"><p ><span style="font-weight: bolder;"> > </span> ITIN Preparation  </p></a>
               <a href="fbar"class="services"><p style="color: #ff6d11;"> <span style="font-weight: bolder;color: #ff6d11;" > ></span> FBAR & FATCA Compliance  </p></a>
               <a href="tax"class="services"><p> <span style="font-weight: bolder;" > ></span> Tax Representation  </p></a>
               <a href="advanced"class="services"><p> <span style="font-weight: bolder;" > ></span> Advanced Tax Planning  </p></a>
               <a href="amendment"class="services"><p> <span style="font-weight: bolder;" > ></span> Amendment Filing  </p></a>
               <a href="evaluation"class="services"><p> <span style="font-weight: bolder;" > ></span> Tax Evaluation  </p></a>
               <a href="filing"class="services"><p> <span style="font-weight: bolder;" > ></span> Extension Filing  </p></a>
            </div>


            <div class="col-sm-7" style="margin-left: 105px;">
                <p style="font-family: Raleway;
                font-size: 24px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.21;
                letter-spacing: 0.24px;
                text-align: left;
                color: #ff6d11;" >FBAR & FATCA Compliance </p>
                <p style="object-fit: contain;
                font-family: Raleway;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.75;
                letter-spacing: 0.13px;
                text-align: left;
                color: #000000;"> All Citizens and Resident Aliens of US are required to file a statement regarding “Report of Foreign Bank and Financial Accounts (FBAR) Form TD F 90-22.1 with IRS, required under Bank Secrecy Act regulations issued by the Financial Crimes Enforcement Network, every year if any taxpayer is having a financial interest / signature authority over financial accounts, including bank(s), securities or any other type of financial accounts in a foreign country, the aggregate value of these financial accounts crosses or exceeds $10,000 at any particular time during the calendar year (Jan 1st 2017 to Dec 31st 2017). The due date for filing the FBAR is April 15th 2018.

    <br> <br><br>  If Taxpayer(s) has more than $50,000 in foreign country as in form of Bank/Securities/Deposits, then each taxpayer has to report it to IRS.FATCA stands for Foreign Account & Tax Compliance Act, FATCA should be Reported by using Form 8938 with IRS along with Income Tax Return on or before April 15th.</p>

                <a href="" style="color: #ff6d11;">https://www.irs.gov/businesses/small-businesses-self-employed/report-of-foreign-bank-and-financial-accounts-fbar</a>
            </div>
            <div class="col-sm-2"></div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 40px"></div>
        </div>



        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 40px"></div>
        </div>

       

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 50px"></div>
        </div>

    
        <div class="row">
            <div class="col-sm-1"></div>

            <div class="col-sm-5">
                <p class="need-help">NEED HELP?</p> <br>
                <p class="need-content">
                        Contact our customer support team if you have any further questions. We are here to help you out.
                </p> <br>

                 <a href="tel:+1(888)690-5754">
                        <button class="btn  btn-sm Number" id="right" style="width: 250px;
                                    height: 50px;
                                    object-fit: contain;
                                    border-radius: 25px;
                                    background-color: #ff6d11;
                                    color: white;">
                        +1 (888) 690 - 5754 &nbsp;
                    </button>
                    </a>
            </div>

            <div class="col-sm-5">
                <img src="assets/section-images/Group 1364.png">
            </div>

            <div class="col-sm-1"></div>
        </div>

        <div class="row">
                <!-- <div class="col" style="height: 1px;"></div> -->
                <div class="col-sm" style="height: 10px;"></div>
                <div class="col-md" style="height: 65px"></div>
                <!-- <div class="col-lg" style="height: 150px;"></div> -->
            </div>
    </section>

</div>

<app-website-footer></app-website-footer>